
class CustomProductSearch {
  constructor(container) {
    this.container = container;

    this.input = container.querySelector(
      ".custom-product-search__input"
    );

    this.clearButton = container.querySelector(
      ".custom-product-search__clear"
    );

    this.results = container.querySelector(
      ".custom-product-search__results"
    );

    this.debounceTimer = null;
    this.abortController = null;

    this.init();
  }

  init() {
    this.input.addEventListener(
      "input",
      this.handleInput.bind(this)
    );

    this.clearButton.addEventListener(
      "click",
      this.clearSearch.bind(this)
    );

    document.addEventListener(
      "click",
      this.handleOutsideClick.bind(this)
    );

    this.input.addEventListener(
      "keydown",
      this.handleKeyboard.bind(this)
    );
  }

  handleInput(event) {
    const query = event.target.value.trim();

    clearTimeout(this.debounceTimer);

    if (!query) {
      this.clearButton.hidden = true;
      this.closeResults();
      return;
    }

    this.clearButton.hidden = false;

    this.debounceTimer = setTimeout(() => {
      this.searchProducts(query);
    }, 300);
  }

  async searchProducts(query) {
    if (this.abortController) {
      this.abortController.abort();
    }

    this.abortController = new AbortController();

    this.showLoading();

    const url =
      `${window.Shopify.routes.root}` +
      `search/suggest.json` +
      `?q=${encodeURIComponent(query)}` +
      `&resources[type]=product` +
      `&resources[limit]=8` +
      `&resources[limit_scope]=each`;

    try {
      const response = await fetch(url, {
        signal: this.abortController.signal
      });

      if (!response.ok) {
        throw new Error("Search request failed");
      }

      const data = await response.json();

      const products =
        data.resources.results.products || [];

      this.renderProducts(products, query);

    } catch (error) {
      if (error.name === "AbortError") {
        return;
      }

      console.error(
        "Product search error:",
        error
      );

      this.results.innerHTML = `
        <div class="custom-product-search__message">
          Something went wrong. Please try again.
        </div>
      `;

      this.openResults();
    }
  }

  showLoading() {
    this.results.innerHTML = `
      <div class="custom-product-search__loading">
        <div class="custom-product-search__spinner"></div>
        <span>Searching products...</span>
      </div>
    `;

    this.openResults();
  }

  renderProducts(products, query) {
    if (!products.length) {
      this.results.innerHTML = `
        <div class="custom-product-search__message">
          No products found for
          "<strong>${this.escapeHTML(query)}</strong>"
        </div>
      `;

      this.openResults();
      return;
    }

    let html = `
      <div class="custom-product-search__heading">
        Products
      </div>

      <div class="custom-product-search__list">
    `;

    products.forEach((product) => {

      const image =
        product.image ||
        product.featured_image?.url ||
        "";

      const price =
        this.formatPrice(product.price);

      html += `
        <a
          href="${product.url}"
          class="custom-product-search__product"
          role="option"
        >

          <div class="custom-product-search__image">

            ${
              image
                ? `
                  <img
                    src="${image}"
                    alt="${this.escapeHTML(product.title)}"
                    loading="lazy"
                  >
                `
                : ""
            }

          </div>


          <div class="custom-product-search__product-info">

            <div class="custom-product-search__product-title">
              ${this.escapeHTML(product.title)}
            </div>

            ${
              price
                ? `
                  <div class="custom-product-search__price">
                    ${price}
                  </div>
                `
                : ""
            }

          </div>

        </a>
      `;
    });

    html += `
      </div>
    `;

    this.results.innerHTML = html;

    this.openResults();
  }

  formatPrice(price) {
  if (
    price === null ||
    price === undefined ||
    price === ""
  ) {
    return "";
  }

  const amount = Number(price);

  if (Number.isNaN(amount)) {
    return price;
  }

  try {
    return new Intl.NumberFormat(
      document.documentElement.lang || "en",
      {
        style: "currency",
        currency:
          window.Shopify.currency?.active ||
          window.Shopify.currency?.shop ||
          "USD"
      }
    ).format(amount);

  } catch (error) {
    return price;
  }
}

  openResults() {
    this.results.hidden = false;

    this.container.classList.add(
      "is-search-open"
    );

    this.input.setAttribute(
      "aria-expanded",
      "true"
    );
  }

  closeResults() {
    this.results.hidden = true;

    this.results.innerHTML = "";

    this.container.classList.remove(
      "is-search-open"
    );

    this.input.setAttribute(
      "aria-expanded",
      "false"
    );
  }

  clearSearch() {
    this.input.value = "";

    this.clearButton.hidden = true;

    this.closeResults();

    this.input.focus();
  }

  handleOutsideClick(event) {
    if (!this.container.contains(event.target)) {
      this.closeResults();
    }
  }

  handleKeyboard(event) {
    if (event.key === "Escape") {
      this.closeResults();
      this.input.blur();
    }
  }

  escapeHTML(value) {
    const div =
      document.createElement("div");

    div.textContent =
      value || "";

    return div.innerHTML;
  }
}


document.addEventListener(
  "DOMContentLoaded",
  () => {

    document
      .querySelectorAll(
        "[data-product-search]"
      )
      .forEach((container) => {

        new CustomProductSearch(container);

      });

  }
);

